export default "__VITE_ASSET__1JojXYbH__"